(() => {
  'use strict';
  if (window.BasuriUI) { window.BasuriUI.init(document); return; }
  const initialized = new WeakSet();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 1025px)');
  const footerMobile = matchMedia('(max-width: 767px)');
  const find = (root, selector) => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  function closeMenu() {
    const menu = document.getElementById('mobile-menu');
    const button = document.querySelector('.menu-toggle');
    if (menu) menu.hidden = true;
    button?.setAttribute('aria-expanded', 'false');
    button?.setAttribute('aria-label', 'Open menu');
  }
  function arrangeFooter() {
    document.querySelectorAll('.footer-links').forEach(menu => { menu.open = !footerMobile.matches; });
  }
  function init(root = document) {
    find(root, '.footer-links').forEach(menu => {
      if (initialized.has(menu)) return;
      initialized.add(menu);
      menu.open = !footerMobile.matches;
      menu.querySelector('summary')?.addEventListener('click', event => { if (!footerMobile.matches) event.preventDefault(); });
    });
    find(root, '#search-dialog').forEach(search => {
      if (initialized.has(search)) return;
      initialized.add(search);
      search.addEventListener('close', () => document.body.classList.remove('search-is-open'));
      search.addEventListener('click', event => {
        if (event.target !== search) return;
        const box = search.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) search.close();
      });
    });
    find(root, '#hero-video').forEach(video => {
      if (initialized.has(video)) return;
      initialized.add(video);
      const toggle = video.closest('.hero')?.querySelector('#video-toggle');
      if (!toggle) return;
      const sync = () => {
        toggle.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video');
        const label = toggle.querySelector('#video-label');
        const symbol = toggle.querySelector('#video-symbol');
        if (label) label.textContent = video.paused ? 'Play film' : 'Pause film';
        if (symbol) symbol.textContent = video.paused ? '▷' : 'Ⅱ';
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('error', () => { toggle.hidden = true; });
      video.querySelector('source')?.addEventListener('error', () => { toggle.hidden = true; });
      toggle.addEventListener('click', () => { if (video.paused) video.play().catch(sync); else video.pause(); });
      if (motion.matches) { video.autoplay = false; video.pause(); toggle.hidden = true; }
      else video.play().catch(sync);
      sync();
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('button,a');
    if (button?.matches('.menu-toggle')) {
      const menu = document.getElementById('mobile-menu');
      if (!menu) return;
      const open = menu.hidden;
      menu.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    } else if (button?.matches('#search-open')) {
      closeMenu();
      const search = document.getElementById('search-dialog');
      if (search && !search.open) { search.showModal(); document.body.classList.add('search-is-open'); }
    } else if (button?.matches('#search-close')) {
      document.getElementById('search-dialog')?.close();
    } else if (!event.target.closest('#mobile-menu,.menu-toggle')) closeMenu();
    if (button?.closest('#mobile-menu') && button.matches('a')) closeMenu();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && document.getElementById('mobile-menu')?.hidden === false) {
      closeMenu(); document.querySelector('.menu-toggle')?.focus();
    }
  });
  desktop.addEventListener('change', event => { if (event.matches) closeMenu(); });
  footerMobile.addEventListener('change', arrangeFooter);
  motion.addEventListener('change', () => {
    document.querySelectorAll('#hero-video').forEach(video => {
      if (motion.matches) { video.autoplay = false; video.pause(); }
      const toggle = video.closest('.hero')?.querySelector('#video-toggle');
      if (toggle) toggle.hidden = motion.matches || !!video.error;
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('video').forEach(video => video.pause());
    event.target.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    if (event.target.querySelector('#search-dialog')) document.body.classList.remove('search-is-open');
  });
  window.addEventListener('pagehide', () => document.querySelectorAll('video').forEach(video => video.pause()));
  window.BasuriUI = { init, closeMenu };
  init();
})();
